import { ready } from "../utils";

ready(() => {
  const immersiveArticleModalContainer = document.getElementById('immersive-article-modal-container');
  if (immersiveArticleModalContainer) {
    const launchBtn = document.getElementById('launch-immersive-article-modal');
    if (!launchBtn) return;
    launchBtn.addEventListener('click', e => {
      e.preventDefault();
      immersiveArticleModalContainer.classList.remove('hidden');
    });

    // Prevent clicks inside the modal from bubbling up to the modal container
    const immersiveArticleModal = document.getElementById('immersive-article-modal');
    immersiveArticleModal.addEventListener('click', e => e.stopPropagation());

    const modalcloseBtn = document.getElementById('immersive-article-modal-close-btn-container');
    [immersiveArticleModalContainer, modalcloseBtn].forEach(elt => {
      elt.addEventListener('click', () => immersiveArticleModalContainer.classList.add('hidden'));
    });
  }
});
